import React from 'react';
import './Help.scss';
import {Col, Container, Row} from "reactstrap";
import Header from "../../../components/Header/Header";
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";
import * as actionClassCreator from "../../../store/domain/classes/action";
import connect from "react-redux/es/connect/connect";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionLectureCreator from "../../../store/domain/lecturer/action";
import {withRouter} from "react-router";
import VideoPlayer from '../../../components/VideoPlayer/YoutubePLayer'

import Slider from "react-slick";
import * as constants from "../../../const/constants";
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";


class Help extends React.Component {
    state = {
        slider: []
    };

    componentDidMount() {
        window.scrollTo(0,0);
        // console.log("Help");
    }


    render() {
        let {userType} = this.props;

        return (
            <div>
                <Header active={3}/>
                <main ref="main" className="help" id={'help'}>
                    <section className="">
                        <Container>
                            <AuthButtonGroup userType={userType}/>


                            <div className="about mt-4 w-100">
                                <p className={"about-para mt-5"}>☑️&nbsp;How to Create Student Account (ශිෂ්‍ය ගිණුමක් සෑදීම)</p>
                                <VideoPlayer class={true} video={'https://youtu.be/ga5ugFtj8YU'}/>

                                <p className={"about-para mt-6"}>☑️&nbsp;How to login to Student Account (ශිෂ්‍යයෙකුට
                                    ගිණුමට පිවිසීම)</p>
                                <VideoPlayer class={true} video={'https://youtu.be/vCX31DydFLA'}/>

                                <p className={"about-para mt-6 "}>☑️&nbsp;How to Change Your Account details
                                    (ශිෂ්‍යයෙකුට ගිණුමේ ප්‍රොෆයිල් තොරතුරැ වෙනස් කිරීම)</p>

                                <VideoPlayer class={true} video={'https://youtu.be/r7ekhAeHfo8'}/>
                                <p className={"about-para mt-6"}>☑️&nbsp;How to Change Your Account details
                                    (ශිෂ්‍යයෙකුට මුරපදය වෙනස් කිරීම)</p>
                                <VideoPlayer class={true} video={'https://youtu.be/zJMymtKa3j0'}/>


                                <p className={"about-para mt-6"}>☑️&nbsp;How to Change Your Account details
                                    (ශිෂ්‍යයෙකුට මුරපදය වෙනස් කිරීම)</p>
                                <VideoPlayer class={true} video={'https://youtu.be/zJMymtKa3j0'}/>

                                <p className={"about-para mt-6"}>
                                    &nbsp;Clear History, Cache in the browser in the android phone (ජංගම දුරකතනයේ cache ,history මකා දැමීම) </p>
                                <VideoPlayer class={true} video={'https://youtu.be/79QO5tckFF0'}/>



                                <p className={"about-para mt-6"}>
                                    &nbsp;Add short cut icon for edulab website</p>
                                <VideoPlayer class={true} video={'https://youtu.be/LVPBJL15PZU'}/>

                                <p className={"about-para mt-6"}>
                                    &nbsp;Reset Web Browser</p>
                                <VideoPlayer class={true} video={'https://youtu.be/w9Q0NnamjLo'}/>

                            </div>
                        </Container>
                    </section>
                </main>
                <CardsFooter />
            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Help));